module.exports = {
  context: {
    parent: {
      title: 'Community Catalysts Services'
    },
    nodes: [
      {
        title: 'Live',
        url: 'http://adjoin.nitro/catalyst-community-services/live',
        current: true,
        children: [
          {
            title: 'Subpage',
            url: 'http://adjoin.nitro/catalyst-community-services/subpage',
            current: true
          },
          {
            title: 'Subpage',
            url: 'http://adjoin.nitro/catalyst-community-services/subpage'
          },
          {
            title: 'Subpage',
            url: 'http://adjoin.nitro/catalyst-community-services/subpage'
          }
        ]
      },
      {
        title: 'Work',
        url: 'http://adjoin.nitro/catalyst-community-services/work'
      },
      {
        title: 'Learn',
        url: 'http://adjoin.nitro/catalyst-community-services/learn',
        children: [
          {
            title: 'Subpage',
            url: 'http://adjoin.nitro/catalyst-community-services/subpage'
          },
          {
            title: 'Subpage',
            url: 'http://adjoin.nitro/catalyst-community-services/subpage'
          },
          {
            title: 'Subpage',
            url: 'http://adjoin.nitro/catalyst-community-services/subpage'
          }
        ]
      },
      {
        title: 'Play',
        url: 'http://adjoin.nitro/catalyst-community-services/play'
      }
    ]
  }
}
